import { handleActions, combineActions } from 'redux-actions'

import * as rawActions from '../actions'

const defaultState = ''

export default handleActions(
  {
    [rawActions.updateTargetContentSearchValue](state, { payload: { searchQuery } }) {
      return searchQuery
    },
    [combineActions(
      rawActions.resetState,
      rawActions.resetShareSessionDialog,
      rawActions.removeOwner,
      rawActions.setTenantForSharing
    )](state, action) {
      return defaultState
    },
  },
  defaultState
)
